module.exports = __webpack_public_path__ + "static/media/1POLICY34.2df17738.jpg";